export enum TranslationKey {

    DailyStop = "DailyStop",
    MinTradingDays = "MinTradingDays",
    ProfitShare = "ProfitShare",
    StopOut = "StopOut",
    TargetProfit = "TargetProfit",
    UIErrorMessage = "UIErrorMessage",
    account = "account",
    accountNumber = "accountNumber",
    addMore = "addMore",
    added = "added",
    addons = "addons",
    addonsDescription = "addonsDescription",
    address = "address",
    amount = "amount",
    apply = "apply",
    back = "back",
    backToPlatform = "backToPlatform",
    bankAddress = "bankAddress",
    bankTransfer = "bankTransfer",
    beneficiaryName = "beneficiaryName",
    buy = "buy",
    callMe = "callMe",
    cancel = "cancel",
    capital = "capital",
    cardHolderName = "cardHolderName",
    chargedAmount = "chargedAmount",
    checkout = "checkout",
    chooseAddons = "chooseAddons",
    choosePreferredBankCurrency = "choosePreferredBankCurrency",
    chooseYourPaymentMethod = "chooseYourPaymentMethod",
    city = "city",
    continueWith = "continueWith",
    continue_ = "continue_",
    copiedToClipboard = "copiedToClipboard",
    country = "country",
    creditCard = "creditCard",
    creditCardNumber = "creditCardNumber",
    creditCardType = "creditCardType",
    currency = "currency",
    cvvInfo = "cvvInfo",
    dailyLoss = "dailyLoss",
    dailyStop = "dailyStop",
    date = "date",
    debitCard = "debitCard",
    deposit = "deposit",
    depositAmount = "depositAmount",
    depositMaxAmount = "depositMaxAmount",
    depositMinAmount = "depositMinAmount",
    depositPageSubtitleDepositSuccessful = "deposit.page.subtitle.DepositSuccessful",
    depositPageSubtitleDepositTopUp = "deposit.page.subtitle.DepositTopUp",
    depositPageTitleDepositSuccessful = "deposit.page.title.DepositSuccessful",
    depositPageTitleDepositTopUp = "deposit.page.title.DepositTopUp",
    documentTitleDepositSuccessful = "document.title.DepositSuccessful",
    documentTitleDepositTopUp = "document.title.DepositTopUp",
    done = "done",
    doubleLeverage = "doubleLeverage",
    eduPkgBeginner = "edu.pkg.Beginner",
    eduPkgDefault = "edu.pkg.Default",
    eduPkgElite = "edu.pkg.Elite",
    eduPkgExpert = "edu.pkg.Expert",
    eduPkgIntermediate = "edu.pkg.Intermediate",
    eduPkgTrader = "edu.pkg.Trader",
    email = "email",
    errorAddress = "error.address",
    errorAmount = "error.amount",
    errorAmountLarge = "error.amount.large",
    errorBank_id = "error.bank_id",
    errorCardCvv = "error.cardCvv",
    errorCardCvvLength = "error.cardCvv.length",
    errorCardExpiration = "error.cardExpiration",
    errorCardExpirationExpired = "error.cardExpirationExpired",
    errorCardName = "error.cardName",
    errorCardNameRegexp = "error.cardName.regexp",
    errorCardNumber = "error.cardNumber",
    errorCardNumberProvider = "error.cardNumber.provider",
    errorCardNumberWrong = "error.cardNumber.wrong",
    errorCity = "error.city",
    errorCountry = "error.country",
    errorDateOfBirth = "error.dateOfBirth",
    errorDepositLimits = "error.depositLimits",
    errorIdCard = "error.idCard",
    errorInvalid = "error.invalid",
    errorInvalidDate = "error.invalid.date",
    errorIsRequired = "error.isRequired",
    errorStreet = "error.street",
    errorZipCode = "error.zipCode",
    expirationDate = "expirationDate",
    expirydate = "expirydate",
    formFieldAddress = "form.field.address",
    formFieldCardCvv = "form.field.cardCvv",
    formFieldCardName = "form.field.cardName",
    formFieldCardNumber = "form.field.cardNumber",
    formFieldCity = "form.field.city",
    formFieldDateOfBirth = "form.field.dateOfBirth",
    formFieldIdCard = "form.field.idCard",
    formFieldMonth = "form.field.month",
    formFieldPromotionCode = "form.field.promotionCode",
    formFieldYear = "form.field.year",
    formFieldZipCode = "form.field.zipCode",
    fullName = "fullName",
    guaranteedSafe = "guaranteedSafe",
    higherProfitShare = "higherProfitShare",
    iban = "iban",
    leverage = "leverage",
    maxLossProfitTarget = "maxLossProfitTarget",
    maximumLoss = "maximumLoss",
    merchantAccountEmail = "merchantAccountEmail",
    minTradingDays = "minTradingDays",
    minimum = "minimum",
    mm = "mm",
    mmYY = "mmYY",
    modalDontCloseWindow = "modal.dontCloseWindow",
    modalPendingMessages = "modal.pendingMessages",
    newsTrading = "newsTrading",
    no = "no",
    noMinTradingDays = "noMinTradingDays",
    ok = "ok",
    orderDetails = "orderDetails",
    otherDetails = "otherDetails",
    otherPaymentMethods = "otherPaymentMethods",
    pay = "pay",
    payByCard = "payByCard",
    paymentProcessing = "paymentProcessing",
    ppGroupCash = "pp.group.Cash",
    ppGroupCreditCard = "pp.group.CreditCard",
    ppGroupCrypto = "pp.group.Crypto",
    ppGroupEWallet = "pp.group.EWallet",
    promoCode = "promoCode",
    propAccountReady = "propAccountReady",
    purchasePackage = "purchasePackage",
    purchasePackageSuccessfully = "purchasePackageSuccessfully",
    purchasedAmount = "purchasedAmount",
    receiptNumber = "receiptNumber",
    recommendedAddons = "recommendedAddons",
    redirectToAPM = "redirectToAPM",
    required = "required",
    secureDeposit = "secureDeposit",
    selectBank = "selectBank",
    selectPackage = "selectPackage",
    selectYourPackage = "selectYourPackage",
    serverErrorGeneral = "server.error.general",
    showLess = "showLess",
    showMore = "showMore",
    startTrading = "startTrading",
    stillPending = "stillPending",
    stopOut = "stopOut",
    success = "success",
    swift = "swift",
    symbolCategory = "symbolCategory",
    targetProfit = "targetProfit",
    topUp = "topUp",
    topUpAgain = "topUpAgain",
    total = "total",
    traderPayoutsGuarantee = "traderPayoutsGuarantee",
    tradingPlatformEmail = "tradingPlatformEmail",
    transactionId = "transactionId",
    unlimitedTradingDays = "unlimitedTradingDays",
    weekendTrading = "weekendTrading",
    willDoLater = "willDoLater",
    yes = "yes",
    yy = "yy",
    zipCode = "zipCode",
}
